import { makeStyles } from '@mui/styles';

export const useAppStyles = makeStyles((theme) => ({
  pageContainer: {
    position: 'relative',
    minHeight: '100vh',
    transition: 'filter 200ms linear',
  },

  contentWrap: {
    paddingBottom: '520px !important',

    [theme.breakpoints.down('lg')]: {
      paddingBottom: '250px !important',
    },
  },
}));
